var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.statusObj.class},[(
      _vm.data.item.status == _vm.consts.fileProcessing.completeWithError.code ||
        _vm.data.item.status == _vm.consts.fileProcessing.failed.code ||
        _vm.data.item.status == _vm.consts.fileProcessing.notCompleted.code
    )?_c('span',{staticClass:"error-count",on:{"click":function($event){return _vm.viewErrorList(_vm.data.item.id)}}},[_vm._v(_vm._s(_vm.statusObj.text)),(_vm.data.item.error_count > 0)?_c('span',[_vm._v("\n      ("+_vm._s(_vm.data.item.error_count)+")")]):_vm._e()]):_c('span',[_vm._v("\n    "+_vm._s(_vm.statusObj.text)+"\n  ")])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7a8ea88c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/transaction-associated/TransactionStatus.vue
// module id = 1610
// module chunks = 181